import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-icone-andarilho',
  standalone: true,
  imports: [],
  templateUrl: './icone-andarilho.component.html',
  styleUrl: './icone-andarilho.component.scss',
})
export class IconeAndarilhoComponent implements OnInit, OnChanges {
  @Input() preenchido = false;
  @Input() bloqueado = false;

  corDaBorda = '#e63d25';
  corDoCirculo = 'white';
  corDoIcone = '#e63d25';

  ngOnInit(): void {
    if (this.preenchido) {
      this.bloqueado = true;
      this.definirEsquemaDeCoresPreenchidas();
      return;
    }

    this.definirEsquemaDeCoresVazio();
  }

  ngOnChanges(changes: any): void {
    if (
      changes.bloqueado &&
      changes.bloqueado.previousValue === false &&
      changes.bloqueado.currentValue === true
    ) {
      this.definirEsquemaDeCoresPreenchidas();
      return;
    }

    if (this.preenchido && !this.bloqueado) {
      this.definirEsquemaDeCoresPreenchidas();
      return;
    }

    if (!this.preenchido && !this.bloqueado) {
      this.definirEsquemaDeCoresVazio();
    }
  }

  definirEsquemaDeCoresPreenchidas(): void {
    this.corDaBorda = '#e63d25';
    this.corDoCirculo = '#e63d25';
    this.corDoIcone = 'white';
  }

  definirEsquemaDeCoresVazio(): void {
    this.corDaBorda = '#e63d25';
    this.corDoCirculo = 'white';
    this.corDoIcone = '#e63d25';
  }
}
